enum ETypyWyjazdu {
  typWartosc = 'TypyWyjazdu',
  wypoczynek = 'wypoczynek',
  objazd = 'objazd',
  objazdPotwierdzony = 'objazd + potwierdzony',
  objazdWypoczynek = 'objazd + wypoczynek',
  objazdWypoczynekPotwierdzony = 'objazd + wypoczynek + potwierdzony',
  narty = 'narty',
}

export default ETypyWyjazdu;
